import React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  typography: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
}))

const StepHeader = ({ title }) => {
  const styles = useStyles()

  return (
    <Typography
      className={styles.typography}
      variant="h6"
      component="h2"
    >
      {title}
    </Typography>
  )
}

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default StepHeader
